export default __webpack_public_path__ + "ff4ea36185a6595f7e76175201f86064.png";